import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaCookie, FaTimes } from 'react-icons/fa';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Verificar si el usuario ya aceptó las cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      // Mostrar el banner después de 1 segundo
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };

  const handleClose = () => {
    setShowBanner(false);
    // Mostrar nuevamente en 24 horas si no aceptaron
    setTimeout(() => setShowBanner(true), 24 * 60 * 60 * 1000);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-[99999] bg-white shadow-2xl border-t-2 border-green-600"
        >
          <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              {/* Icono y texto */}
              <div className="flex items-start gap-3 flex-1">
                <FaCookie className="text-amber-600 text-3xl flex-shrink-0 mt-1" />
                <div className="text-sm sm:text-base text-gray-700">
                  <p className="font-semibold mb-1">🍪 Uso de Cookies</p>
                  <p>
                    Utilizamos cookies para mejorar tu experiencia de navegación, 
                    recordar tus preferencias y analizar el tráfico del sitio. 
                    Al hacer clic en "Aceptar", aceptas el uso de cookies.{' '}
                    <Link 
                      to="/politica-de-privacidad" 
                      className="text-green-600 hover:text-green-700 underline font-medium"
                    >
                      Más información
                    </Link>
                  </p>
                </div>
              </div>

              {/* Botones */}
              <div className="flex gap-3 flex-shrink-0">
                <button
                  onClick={handleClose}
                  className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors"
                  aria-label="Cerrar banner de cookies"
                >
                  <FaTimes size={18} />
                </button>
                <button
                  onClick={handleAccept}
                  className="px-6 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-all shadow-md hover:shadow-lg"
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
